export const SIDEBAR_NAME = {
  addQuestion: "addQuestion",
  addActionButton: "addActionButton",
  addActionForm: "addActionForm",
  clickBehavior: "clickBehavior",
  editParameter: "editParameter",
  sharing: "sharing",
  info: "info",
};
